const articles =
{
    helmet :
    {
        title : 'Articles' ,
        metas : []
    }
};

export default articles ;